export default __webpack_public_path__ + "static/media/Pursuit Roasting Company.baa4db8d.svg";